import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
import { HelperText } from "../helper-text";
import { TextInput } from "./TextInput";
export const TextInputWithValidation = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {string} props.name
 * @param {string} props.placeholder
 * @param {string} props.title
 * @param {any} [props.className]
 * @param {(props: { [key: string]: any }) => JSX.Element} [props.TextInput]
 * @param {{ [name: string]: { message: string } }} props.errors
 * @returns
 */
function TextInputWithValidation({
  name,
  placeholder,
  title,
  className,
  errors,
  TextInput,
  ...props
}, ref) {
  const inputClass = classNames(["w-full", "mb-5"], className);
  return /*#__PURE__*/React.createElement("div", {
    className: inputClass
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    name: name,
    placeholder: placeholder,
    title: title,
    ref: ref,
    valid: !errors[name],
    className: "w-full"
  }, props)), errors[name] && /*#__PURE__*/React.createElement(HelperText, {
    valid: false
  }, errors[name].message));
});
TextInputWithValidation.defaultProps = {
  TextInput
};
TextInputWithValidation.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  errors: PropTypes.any,
  TextInput: PropTypes.func
};